// @ts-strict-ignore
import { useProduct } from '@/screens/Product/hooks/useProduct'

import { unEscape } from '@/shared/lib/utils/string/un-escape'
import { Col, Row } from '@/shared/ui/Grid'

import { ProductPanel } from './product-panel'
import { ProductSlider } from './product-slider'

import cl from './product-page-main.module.scss'

export const ProductPageMain = (): JSX.Element => {
	const { product } = useProduct()

	return (
		<>
			<section className={cl.productMain}>
				<Row gutter={{ xs: 24, sm: 24, md: 24, lg: 40 }}>
					<Col xs={24} lg={11}>
						<ProductSlider />

						<p className={cl.productMainMobileTitle}>{unEscape(product.TITLE)}</p>
					</Col>

					<Col lg={13} xs={24}>
						<ProductPanel />
					</Col>
				</Row>
			</section>
		</>
	)
}
